import { PropsWithChildren, createContext } from "react";

import { ProcessProgressDialog } from "./components/process-progress-dialog";
import { useProcessProvider } from "./hooks/use-process-provider";
import { ProcessContextValue } from "./types/process-provider-types";

export const ProcessContext = createContext<ProcessContextValue>({
  runningProcesses: [],
  startRun: async () => null,
  errors: undefined,
});

export function ProcessProvider({ children }: PropsWithChildren) {
  const { trackedRuns, startRun, errors } = useProcessProvider();

  return (
    <ProcessContext.Provider
      value={{
        runningProcesses: trackedRuns,
        startRun,
        errors,
      }}
    >
      <ProcessProgressDialog processes={trackedRuns} />
      {children}
    </ProcessContext.Provider>
  );
}
